import React, { useEffect, useState, useRef } from "react";
import { PopPlayer } from "components/PopPlayer";
import { PopTools } from "components/PopTools";
import { useAudioStateContext } from "hooks/useAudioStateContext";
import { useAudioHandlesContext } from "hooks/useAudioHandlesContext";
import { getOneTrack } from "./utilst";
import { IVoiceType } from "types";
import { useSubmit } from "./hooks/useSubmit";
import { AudioTrack, MetadataToSubtitlesLanguages } from "providers/AudioProvider/types";
import { getPrevTrackId } from "providers/AudioProvider/helpers";
import { Preloader } from "components/elements/Preloader";

const FAST_API_URL = process.env.REACT_APP_FAST_API_URL;
const cols = 79;

interface IPop2Props {
  oneTrackId: string;
  handleClose: (val: boolean) => void;
}

export const SubtitleEditorModal: React.FC<IPop2Props> = ({ oneTrackId, handleClose }) => {
  const handles = useAudioHandlesContext();
  const state = useAudioStateContext();
  const subtitleMode = state.subtitleMode;
  const lang = state.lang;
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const [oneTrack, setOneTrack] = useState<AudioTrack>();
  const [shown1, setShown1] = useState(false);
  const [shown2, setShown2] = useState(false);
  const [captions, setCaptions] = useState<string[]>([]);
  const [voice, setVoice] = useState<IVoiceType[]>();
  const [speed, setSpeed] = useState<number[]>();
  const [background, setBackground] = useState<boolean[]>([false]);
  const [changed, setChanged] = useState<boolean>(false);
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const [move, setMove] = useState<number>();
  const [newPop, setNewPop] = useState<string>();
  const [opacity, setOpacity] = useState<number>(1);

  useEffect(() => {
    if (state.translationTrackAll[state.lang]?.length) {
      let oneTrack = getOneTrack(oneTrackId, state, state.originalLang);
      setOneTrack(oneTrack);
      setCaptions(oneTrack?.captions ? [oneTrack.captions] : []);
      setVoice(oneTrack?.voice ? [oneTrack.voice] : undefined);
      setSpeed(oneTrack?.speed ? [oneTrack.speed] : undefined);
      setBackground(oneTrack?.add_background ? [oneTrack.add_background] : [false]);
    }
  }, [state.translationTrackAll[state.lang], oneTrackId]);

  useEffect(() => {
    console.log("background = ", background);
  }, [background]);

  useEffect(() => {
    setChanged(false);
  }, [oneTrackId]);

  const handleClosePop = () => {
    setShown2(false);
    setTimeout(() => {
      setShown1(false);
      handleClose(false);
      handles.showSubtitleEditor();
    }, 5);
  };

  const { handleSubmit } = useSubmit({
    oneTrack,
    captions,
    voice,
    speed,
    subtitleMode,
    handles,
    handleClosePop,
    state,
  });

  const [masterError, setMasterError] = useState<string | null>(null);
  const [masterSaving, setMasterSaving] = useState(false);

  // «Сохранить и в оригинал (ru_ru)»: the normal save flow first (same single-caption
  // path as Apply), then write the same text into the ru_ru master and its pair copy.
  // Only offered while the text has no line breaks — the split flow is excluded.
  const handleSubmitToMaster = async () => {
    if (!oneTrack || captions.length !== 1 || masterSaving) {
      return;
    }
    setMasterError(null);
    setMasterSaving(true);
    try {
      if (captions[0] !== oneTrack.captions) {
        void handles.editRusSubtitle({
          track: oneTrack,
          captions: captions[0],
          lang: MetadataToSubtitlesLanguages[state.originalLang],
        });
      }
      const result = await handles.editMasterRuSubtitle({
        id: oneTrack.original_id,
        folder_num: parseInt(oneTrack.folder_num),
        captions: captions[0],
      });
      if (result?.error) {
        setMasterError(result.error); // e.g. the backend 404 message, verbatim
        return;
      }
      handleClosePop();
    } finally {
      setMasterSaving(false);
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  useEffect(() => {
    if (
      oneTrack &&
      (oneTrack.voice !== voice?.[0] ||
        oneTrack.speed !== speed?.[0] ||
        oneTrack.add_background !== background[0] ||
        oneTrack.captions !== captions[0])
    ) {
      setChanged(true);
    } else {
      setChanged(false);
    }
  }, [speed, voice, captions, oneTrackId]);

  useEffect(() => {
    setShown1(true);
    setTimeout(() => {
      setShown2(true);
      // context.handles.setPopOpen(true)
    }, 5);
  }, []);

  const handleReset = () => {
    setCaptions(oneTrack ? [oneTrack.captions] : []);
    setVoice(oneTrack?.voice ? [oneTrack.voice] : undefined);
    setSpeed(oneTrack?.speed ? [oneTrack.speed] : undefined);
    setBackground(oneTrack?.add_background ? [oneTrack.add_background] : [false]);
    setChanged(false);
  };

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [textareaRef.current]);

  const handleChangeCaptions = (index: number) => (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    let newCaps: string[] = [""];
    const newText = e.target.value;

    if (newText === "" || !newText) {
      let newCaptions: string[] = captions.slice();
      newCaptions.splice(index, 1);
      console.log("newCaptions = ", newCaptions);
      newCaps = newCaptions.length ? newCaptions : [""];
    }

    if (newText) {
      if (newText.split("\n").length > 0 && newText !== captions[0]) {
        const makeBrokenCaptions = (newValue: string) => {
          let splidedVal = newValue.split("\n");
          return [...captions.slice(0, index), ...splidedVal, ...captions.slice(index + 1)];
        };
        newCaps = makeBrokenCaptions(newText);
      } else {
        // newCaps = captions.map((one, ind) => index === ind && value);
        // TODO что тут хотели сделать?
        // newCaps = captions.splice().map((one, ind) => index === ind && value);
        console.log("newCaps = ", newCaps);
      }
    }
    setCaptions(newCaps);
  };

  useEffect(() => {
    captions.forEach((one, index) => {
      if (voice && !voice?.[index]) {
        const newArr = voice.slice();
        newArr[index] = newArr[0];
        setVoice(newArr);
      }
      if (speed && !speed[index]) {
        const newArr = speed.slice();
        newArr[index] = newArr[0];
        setSpeed(newArr);
      }
      if (!background[index]) {
        const newArr = background.slice();
        newArr[index] = newArr[0];
        setBackground(newArr);
      }
    });
  }, [captions]);

  useEffect(() => {
    if (move) {
      // setOpacity(0)
      setTimeout(() => {
        setMove(0);
      }, 200);

      setTimeout(() => {
        handles.showSubtitleEditor(newPop);
        // setOpacity(1);
      }, 400);
    }
  }, [move]);

  return (
    <>
      {oneTrack && (
        <div className={shown1 ? "p0 active" : "p0"}>
          <div
            className="p_arr p_arr--prev"
            onClick={() => {
              setNewPop(getPrevTrackId(oneTrackId, state.translationTrackAll[state.lang] || []));
              setMove(20);
            }}
          >
            <div className="ico ico--100">
              <div>navigate_before</div>
            </div>
          </div>

          <div
            className="p_arr"
            onClick={() => {
              setNewPop(handles.getNextTrackId(oneTrackId) || undefined);
              // setNewPop(context.handles.setPop(context.handles.getNextTrackId(oneTrackId)))
              setMove(-20);
              // context.handles.setPop(context.handles.getNextTrackId(oneTrackId))
            }}
          >
            <div className="ico ico--100">
              <div>navigate_next</div>
            </div>
          </div>

          <div
            className={shown2 ? "p_b active" : "p_b"}
            style={{
              transform: `translateX(${move}px)`,
              opacity: `${opacity}`,
            }}
          >
            <div className="p_b_top">
              <div className="p_b_title">
                <div className="ico">edit</div>
                {!subtitleMode && <>Change translation</>}
                {subtitleMode && <>Editing subtitles</>}
              </div>
              <div className="p_b_x" onClick={() => handleClosePop()}>
                <div className="ico">
                  <div>close</div>
                </div>
              </div>
            </div>
            <div className="p_b_c">
              {/*{!subtitleMode && (*/}
              {/*  <div className="p_b_player">*/}
              {/*    {state.mp3 && (*/}
              {/*      <PopPlayer*/}
              {/*        spaceBar={isFocused ? false : true}*/}
              {/*        id={oneTrack["id"]}*/}
              {/*        // handleClick={() => {*/}
              {/*        //   setLeftPadding(Math.floor(marginLeft / zoomLevel + 40))*/}
              {/*        // }}*/}
              {/*        width={"10em"}*/}
              {/*        mp3={`${FAST_API_URL}/${oneTrack["file"]}`}*/}
              {/*        outsideContext={{ state, handles }}*/}
              {/*      ></PopPlayer>*/}
              {/*    )}*/}
              {/*  </div>*/}
              {/*)}*/}

              <div className="p_b_text">
                <div className="p_b_textarea00">
                  {captions.map((one, index, arr) => {
                    if (one === undefined) {
                      return null;
                    }

                    return (
                      <div className="p_b_textarea0" key={index}>
                        {/* {breaks.map((one, ind, arr) => {
                  const tops = [

                  ]
                  return (<>
                    {ind !== arr.length - 1 && <Break key={ind} top={(one + ind) * 30} />}
                  </>)
                })} */}
                        <textarea
                          style={{
                            // width: 'auto',
                            minHeight: captions.length > 1 ? "7em" : "9em",
                          }}
                          cols={cols}
                          ref={textareaRef}
                          value={captions[index]}
                          onChange={handleChangeCaptions(index)}
                          onFocus={handleFocus}
                          onBlur={handleBlur}
                          maxLength={5000}
                          id="field"
                          name="field"
                          data-name="Field"
                          className="p_b_textarea w-input"
                        />
                        {!subtitleMode && (
                          <PopTools
                            handleVoice={(value, ind) =>
                              setVoice((prevValue) =>
                                prevValue?.map((one, index) => (index === ind ? value : one)),
                              )
                            }
                            handleSpeed={(value, ind) =>
                              setSpeed((prevValue) =>
                                prevValue?.map((one, index) => (index === ind ? value : one)),
                              )
                            }
                            handleBackground={(value, ind) =>
                              setBackground((prevValue) =>
                                prevValue.map((one, index) => (index === ind ? value : one)),
                              )
                            }
                            voice={voice?.[index]}
                            speed={speed?.[index]}
                            background={background[index]}
                            index={index}
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="p_b_note">
                <div>☝️ Pressing Enter (line feed) will split the fragment into two parts.</div>
              </div>
              <div className="p_b_bot">
                <div className="p_b_sub">
                  <div
                    className="x_delete"
                    onClick={() =>
                      subtitleMode
                        ? handles.deleteSubtitle(oneTrack)
                        : handles.deleteFragment(oneTrack)
                    }
                  >
                    <div className="ico">
                      <div>delete_forever</div>
                    </div>
                  </div>
                </div>

                {changed && !state.waitingCut.includes(oneTrack.original_id) && (
                  <div className="x_save x_save--cancel" onClick={() => handleReset()}>
                    Reset all changes
                  </div>
                )}

                {!state.waitingCut.includes(oneTrack.original_id) && (
                  <button
                    className={changed ? "x_save" : "x_save x_save--cancel"}
                    style={{ opacity: changed ? 1 : 0.3 }}
                    // disabled={!changed}
                    onClick={handleSubmit}
                  >
                    Apply
                  </button>
                )}

                {subtitleMode &&
                  captions.length === 1 &&
                  !state.waitingCut.includes(oneTrack.original_id) && (
                    <button
                      className="x_save"
                      style={{ opacity: masterSaving ? 0.5 : 1 }}
                      title="Сохранить правку и записать её же в оригинал (мастер ru_ru)"
                      onClick={handleSubmitToMaster}
                    >
                      {masterSaving ? "Wait..." : "Сохранить и в оригинал (ru_ru)"}
                    </button>
                  )}

                {state.waitingCut.includes(oneTrack.original_id) && (
                  <div
                    className={"x_save x_save--cancel"}
                    style={{ cursor: "disabled" }}
                    onClick={handleSubmit}
                  >
                    Wait...
                  </div>
                )}
              </div>

              {masterError && (
                <div style={{ color: "red", fontSize: "0.85em", padding: "0.5em 0" }}>
                  {masterError}
                </div>
              )}
            </div>
            {state.waitingCut.includes(oneTrack.original_id) && <Preloader />}
          </div>

          <div onClick={() => handleClosePop()} className={shown2 ? "p_z active" : "p_z"} />
        </div>
      )}
    </>
  );
};

export function Break({ top = 0 }) {
  return (
    <div style={{ top: top }} className="p_b_textarea_break inact">
      {/* <div>-----------------------------------------------</div> */}
      <div className="ico">content_cut</div>
      {/* <div>-----------------------------------------------</div> */}
    </div>
  );
}
